import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import App from './App';
import './index.scss';
import './styles.css';
import * as serviceWorker from './serviceWorker';
import { store } from './store/configureStore';

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
